import { DatasetDataValue } from 'types/GlobalWidget'

import { isNumberDatasetType, parseDatasetValue } from 'utils/functions'

import { ParsedData } from 'utils/underlyingData'

export function getExportableData(input: ParsedData) {
  const headers = input.columns
    .filter((col) => !col.hidden)
    .map((col) => col.label)
  const rows = input.rows.map((row) => {
    const outputRow: { [key: string]: string | number | null } = {}

    outputRow[row.segment.label] = row.segment.label

    Object.entries(row.values).forEach(([key, value]) => {
      const column = input.columns.find((col) => col.id === key)

      if (column && !column.hidden) {
        const dataValue = parseDatasetValue(
          value as DatasetDataValue,
          column.type
        )

        if (isNumberDatasetType(column.type)) {
          outputRow[column.label] = dataValue as number | null
        } else {
          outputRow[column.label] = (dataValue as string[]).join(',')
        }
      }
    })

    return outputRow
  })

  return { headers, rows }
}
